import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from 'common/components/elements/buttons/primary';
import  ColorPicker  from 'common/components/elements/color-picker';
import { Tooltip } from 'react-tooltip';
import { createPortal } from 'react-dom';
import transparent from 'assets/images/transparent.png';

const ColorsSection = ({
   options,
   value,
   onChange,
   name,
   isFontColor,
   hideColorPicker,
}) => {
   const isCustomColor = (color) => {
      if(color && options){
         return !options.includes(color);
      }
      return false;
   }
   const [openColorPicker, setOpenColorPicker] = useState(false);
   const [customColor, setCustomColor] = useState(!hideColorPicker && isCustomColor(value) ? value : '');
   return (
      <div className='flex justify-between'>
         <div className='flex gap-2'>
            {
               customColor && (
                  <ColorCard
                     color={ customColor }
                     onChange={ onChange }
                     isSelected={ customColor === value }
                     isCustomColor={ isCustomColor(customColor) }
                     name={ name }
                  />
               )
            }
            {
               options && options.map((color, index) => {

                  return (
                     <ColorCard
                        key={ index.toString() }
                        color={ color }
                        onChange={ onChange }
                        isSelected={ color === value }
                        isCustomColor={ isCustomColor(color) }
                        name={ name }
                        isFontColor={ isFontColor }
                     />
                  )
               })
            }
         </div>
         {
            !hideColorPicker &&
            <div
               data-tooltip-id='color-picker-section'
               className='h-9 w-9 flex'>
               <Button
                  classNames='w-full h-full'
                  iconName='color-picker'
                  fontIconColor='secondary'
                  darkIconColor='secondary-dark'
                  backgroundColor='transparent'
                  padding='0'
                  onClick={ _ => setOpenColorPicker(!openColorPicker) }
               />
            </div>
         }
         {
            createPortal(
               <ColorPallet
                  openColorPicker={ openColorPicker }
                  color={ customColor }
                  handleChangeColor={ (color) => {
                     const newCustomColor = color?.hex;
                     if(newCustomColor){
                        setCustomColor(newCustomColor);
                        if(value !== newCustomColor){
                           onChange(name, newCustomColor);
                        }
                     }
                  } }
                  id='color-picker-section'
               />,
               document.getElementById('tooltips')
            )
         }
      </div>
   )
}

const ColorPallet = ({
   openColorPicker,
   color,
   handleChangeColor,
   id,
}) => {
   return (
      <Tooltip
         openOnClick
         role='dialog'
         variant='light'
         id={ id }
         place='bottom'
         clickable
         isOpen={ openColorPicker }
         offset={ 4 }
         noArrow
         style={ {
            padding: 0,
            borderRadius: '8px',
         } }
         className='shadow-dropdown dark:shadow-dark border dark:border-divider-dark border-divider min-w-[200px] z-60'
      >
         <ColorPicker
            color={ color }
            handleChangeColor={ handleChangeColor }
         />

      </Tooltip >
   )
}

const ColorCard = ({
   onChange,
   color,
   isSelected,
   name,
}) => {
   return (
      <div
         role='presentation'
         onClick={ () => {
            if(onChange){
               onChange(name, color);
            }
         } }
         className={ cx({
            'w-10 h-10 min-w-[10px] rounded-full flex items-center justify-center cursor-pointer overflow-hidden': true,
            'border-2 border-action': isSelected,
         }) }
      >
         {
            color !== 'transparent' && (
               <div
                  style={ {
                     background: color,
                  } }
                  className={ cx({
                     'w-8 h-8 min-w-[32px] rounded-full border border-divider': true,
                     // [`bg-${ color }`]: !isCustomColor,
                  }) }
               />
            )
         }
         {
            color === 'transparent' && (
               <img alt='transparent' src={ transparent } className='h-full w-full rounded-lg' />
            )
         }
      </div>
   )
}

ColorsSection.defaultProps = {
   onChange: () => {},
   name: 'color',
   hideColorPicker: false,
}
ColorsSection.propTypes = {
   options: PropTypes.array,
   value: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
   isFontColor: PropTypes.bool,
   hideColorPicker: PropTypes.bool,
};
ColorCard.propTypes = {
   onChange: PropTypes.func,
   color: PropTypes.any,
   isSelected: PropTypes.bool,
   name: PropTypes.string,
};
ColorPallet.propTypes = {
   handleChangeColor: PropTypes.func,
   color: PropTypes.string,
   openColorPicker: PropTypes.bool,
   id: PropTypes.string,
};

export default ColorsSection;
export { ColorCard, ColorPallet }
